import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InviteFormComponent } from './invite-form/invite-form.component';
import { InviteListComponent } from './invite-list/invite-list.conmponent';

const routes: Routes = [
    {
        path: '',
        component: InviteListComponent
    },
    {
        path: ':id',
        component: InviteFormComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InvitesRoutingModule { }
